import React, { useState } from 'react'
import classNames from 'classnames'
import Icon from 'components/uiElements/Icon'
import { string, arrayOf, func } from 'prop-types'

require('./ImagePicker.scss')

const ImagePicker = ({ images, thumbUrl, name, onLoad }) => {
    const [selectedImageIndex, setSelectedImageIndex] = useState(0)

    if (!images || images.length === 1) {
        return (
            <div className="ImagePicker">
                <img onLoad={onLoad} src={`${thumbUrl}?f=u`} alt={name} className="singleImage" />
            </div>
        )
    }

    // refs will store a ref for each image so that it can be scrolled into view.
    const refs = {}

    const scrollSelectedImageIntoView = () => {
        const selectedImageElement = refs[selectedImageIndex].current
        if (selectedImageElement) {
            selectedImageElement.scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
                block: 'nearest',
            })
        }
    }

    const onPrevImageClick = (e) => {
        e.stopPropagation()
        if (selectedImageIndex > 0) {
            setSelectedImageIndex(selectedImageIndex - 1)
            scrollSelectedImageIntoView()
        }
    }

    const onNextImageClick = (e) => {
        e.stopPropagation()
        if (selectedImageIndex < images.length - 1) {
            setSelectedImageIndex(selectedImageIndex + 1)
            scrollSelectedImageIntoView()
        }
    }

    const selectedImageUrl = images[selectedImageIndex]
    return (
        <div className="ImagePicker">
            <div className="mainImageContainer">
                <div className="buttonOuterContainer">
                    <div className="buttonInnerContainer">
                        <button onClick={onPrevImageClick} disabled={selectedImageIndex === 0}>
                            <Icon svg code="chevron_left" />
                        </button>
                        <button onClick={onNextImageClick} disabled={selectedImageIndex === images.length - 1}>
                            <Icon svg code="chevron_right" />
                        </button>
                    </div>
                </div>
                <img className="mainImage" src={selectedImageUrl} alt={name} />
            </div>
            <ul className="sliderContainer">
                {images.map((image, index) => {
                    refs[index] = React.createRef()
                    return (
                        <li
                            className={classNames('sliderImage', { isSelected: index === selectedImageIndex })}
                            key={image}
                            ref={refs[index]}
                        >
                            <button onClick={() => setSelectedImageIndex(index)}>
                                <img src={image} alt={name} />
                            </button>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

ImagePicker.defaultProps = {
    images: [],
    onLoad: () => {},
}

ImagePicker.propTypes = {
    images: arrayOf(string),
    thumbUrl: string.isRequired,
    name: string.isRequired,
    onLoad: func,
}

export default ImagePicker
